import Footer from './Footer';
import Header from './Header';

const Layout = (props) => {
  return (
    <div className="flex flex-col w-screen h-screen">
      <Header />
      <div className="flex-1 w-screen grid py-5 px-4 bg-white  justify-items-center justify-center content-evenly">
        {props.children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
